export interface EntrepriseSettings {
  nom: string;
  slogan: string;
  adresse: string;
  telephone: string;
  email: string;
  logoUrl: string;
  headerText: string;
  footerText: string;
  nif: string;
  rccm: string;
  devise: string;
  couleurPrimaire: string;
  clientObligatoireVente?: boolean | number;
  gmtOffset?: number;
}

export const entrepriseSettingsMock: EntrepriseSettings = {
  nom: 'Atelier Bassoum Couture',
  slogan: 'L\'élégance africaine, sur mesure',
  adresse: 'Rue 312 Hamdallaye ACI, Bamako, Mali',
  telephone: '+223 76 00 11 22',
  email: 'contact@atelierbassoum.ml',
  logoUrl: '',
  headerText: 'Facture / Reçu de paiement',
  footerText: 'Merci pour votre confiance. Tout article vendu ne peut être ni repris, ni échangé sauf vice de fabrication.',
  nif: 'NIF-ML-2024-00123',
  rccm: 'RCCM-BKO-2022-B-456',
  devise: 'FCFA',
  couleurPrimaire: '#4a7c59',
  clientObligatoireVente: 0,
  gmtOffset: 0,
};
